import { useParams } from 'react-router-dom';

import { ProjectAgentsSection } from './ProjectAgentsSection';
import { ProjectRepositorySection } from './ProjectRepositorySection';

/**
 * «AI-агенты» в настройках проекта (docs/17 §12.2): репозиторий проекта,
 * AI-аналитик и AI-разработчик, неактивная карточка своего аналитика.
 */
export function ProjectAgentsSettingsPage() {
  const { key = '' } = useParams<{ key: string }>();

  return (
    <>
      <ProjectRepositorySection projectKey={key} />
      <ProjectAgentsSection projectKey={key} />
    </>
  );
}
